import React from 'react';
import Img from '../../Img';
import { ballTypeIds } from '../../../utils/eventConstants';

// eslint-disable-next-line
import styles from './ballType.scss';

const BallType = (props) => {
    const { ballType } = props;
    const ballTypeId = typeof ballType === 'object' && ballType !== ballTypeIds.YELLOW ? ballType?.id : ballType;

    const getBallType = () => {
        switch (ballTypeId) {
            case ballTypeIds.RED:
                return <div className="content-wrapper"><Img className="img" src="/img/progression_ball_red.svg" /> Red Ball </div>;
            case ballTypeIds.ORANGE:
                return <div className="content-wrapper"><Img className="img" src="/img/progression_ball_orange.svg" /> Orange Ball </div>;
            case ballTypeIds.GREEN:
                return <div className="content-wrapper"><Img className="img" src="/img/progression_ball_green.svg" /> Green Ball </div>;
            default:
                return null;
        }
    };

    return (
        <div>
            {getBallType()}
        </div>
    );
};

export default BallType;
